import { render } from "./PriceQuotationSheetDetail.vue?vue&type=template&id=4c83e70c&scoped=true&ts=true"
import script from "./PriceQuotationSheetDetail.vue?vue&type=script&lang=ts"
export * from "./PriceQuotationSheetDetail.vue?vue&type=script&lang=ts"

import "./PriceQuotationSheetDetail.vue?vue&type=style&index=0&id=4c83e70c&lang=sass&scoped=true"
import "./PriceQuotationSheetDetail.vue?vue&type=style&index=1&id=4c83e70c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c83e70c"]])

export default __exports__